import StartRecordingIcon from "../../assets/images/start_recording.svg";
import HelloAppLogo from "../../assets/images/hello-logo.svg";
import { PiWaveformLight } from "react-icons/pi";
import "./styles.scss";

function GettingStarted() {
    return (
        <div className="d-flex flex-column gap-2">
            <div>
                <img src={HelloAppLogo} alt="Hello App Logo" width={150} />
            </div>
            <div className="d-flex flex-column g-3">
                <h1 className="line">Ready when you are...</h1>
                <h1 className="d-inline-flex flex-wrap line fw-bold">
                    Press the <span className="listen-text-banner mx-2">Listen Button</span>
                    <div className="listen-button me-2"><PiWaveformLight size={"2.5rem"} fill={"white"}/></div>
                    below,
                </h1>
                <h1 className="line">Speak in your language, and I’ll handle the rest.</h1>
            </div>
        </div>
    )
}

export default GettingStarted;
